import { useFormik } from 'formik';
import { Row } from 'antd';
import * as Yup from 'yup';
import { getRequiredMessage } from 'views/declarations/utils/validation-utils';
import FormTextArea from 'components/new-ui/composed/formTextArea/FormTextArea';
import Button from 'components/new-ui/base/button/Button';

type Props = {
    onSubmit?: () => void;
    onCancel?: () => void;
};

export const validationSchema = Yup.object().shape({
    content: Yup.string().trim().nullable().required(getRequiredMessage('content')),
});

const ReplyToNoteForm = ({ onSubmit, onCancel }: Props) => {
    const formik = useFormik({
        initialValues: {
            content: '',
        },
        validationSchema: validationSchema,
        onSubmit: () => onSubmit?.(),
    });

    return (
        <form onSubmit={formik.handleSubmit}>
            <FormTextArea
                placeholder="Add Note"
                fieldProps={formik.getFieldProps('content')}
                fieldHelper={formik.getFieldHelpers('content')}
                fieldMeta={formik.getFieldMeta('content')}
            />
            <Row
                justify="end"
                style={{
                    marginTop: 8,
                }}
            >
                <Button
                    htmlType="button"
                    onClick={() => {
                        formik.resetForm();
                        onCancel?.();
                    }}
                >
                    Cancel
                </Button>
                <Button
                    loading={formik.isSubmitting}
                    disabled={!formik.isValid}
                    htmlType="submit"
                    style={{ marginLeft: 8 }}
                    type="primary"
                >
                    Reply
                </Button>
            </Row>
        </form>
    );
};

export default ReplyToNoteForm;
